export const document_types = (state) => state.document_types

export const getDocumentTypeById = (state) => (id) => {
  return state.document_types.find(doc_type => doc_type.id === id)
}